import { BaseFileUploader } from '@/abstracts/base-file-uploader';
import { ProcessorType, type UploadingOptions } from '@/store/file-uploader.interface';
import type { FileVersion } from '@/store/file.interface';
import { dataURLtoBlob } from '@/utils/image.helper';

export class FileUploaderV1 extends BaseFileUploader {
  public constructor(version: FileVersion) {
    super(version);
  }

  public async upload(options: UploadingOptions): Promise<void> {
    const formData = new FormData();
    switch (options.processorType) {
      case ProcessorType.Formidable: {
        if (options.data) formData.append('data', JSON.stringify(options.data));
        if (options.image) formData.append('image', dataURLtoBlob(options.image));
        break;
      }
    }
    await options.method(options.url, formData, 'json', { 'x-file-uploader-version': this._version });
  }
}
